export default "__VITE_ASSET__CaE28Nw2__"